import{buildFormatDate as t}from"../utils/date.js";function r(r){return t(r)}export{r as default};
